export default __webpack_public_path__ + "static/media/list-of-motifs-img.605a2846.svg";